// extracted by mini-css-extract-plugin
module.exports = {"custom":"_451d985c6617190503abef70e70f8f97-less"};